import io from "socket.io-client";
import { apiSlice } from "../api/apiSlice";

export const messagesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMessages: builder.query({
      query: (id) =>
        `/messages?conversationId=${id}&_sort=timestamp&_order=desc&_page=1&_limit=${process.env.REACT_APP_MESSAGES_LIMIT_PER_PAGE}`,
      transformResponse(apiResponse, meta) {
        const totalMessages = meta.response.headers.get("X-Total-Count");
        return {
          data: apiResponse,
          totalMessages,
        };
      },
      async onCacheEntryAdded(
        arg,
        { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
      ) {
        const socket = io(process.env.REACT_APP_API_URL, {
          reconnectionDelay: 1000,
          reconnection: true,
          reconnectionAttemps: 10,
          transports: ["websocket"],
          agent: false,
          upgrade: false,
          rejectUnauthorized: false,
        });

        try {
          await cacheDataLoaded;
          socket.on("message", (data) => {
            updateCachedData((draft) => {
              const conversationIndex = draft.data.findIndex(
                (c) => c.conversationId == data?.data?.conversationId
              );

              if (conversationIndex !== -1) {
                draft.data.push(data?.data);
              }
            });
          });
        } catch (error) {}

        await cacheEntryRemoved;
        socket.close();
      },
    }),
    getMoreMessages: builder.query({
      query: ({ id, page }) =>
        `/messages?conversationId=${id}&_sort=timestamp&_order=desc&_page=${page}&_limit=${process.env.REACT_APP_MESSAGES_LIMIT_PER_PAGE}`,
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;

          console.log(data);

          if (data.length > 0) {
            dispatch(
              apiSlice.util.updateQueryData(
                "getMessages",
                arg.id.toString(),
                (draft) => {
                  return {
                    data: [...draft.data, ...data],
                    totalMessages: draft.totalMessages,
                  };
                }
              )
            );
          }
        } catch (error) {}
      },
    }),
    addMessage: builder.mutation({
      query: (data) => ({
        url: "/messages",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const message = await queryFulfilled;

          dispatch(
            apiSlice.util.updateQueryData(
              "getMessages",
              message.conversationId.toString(),
              (draft) => {
                draft.data.push(message);
              }
            )
          );
        } catch (error) {}
      },
    }),
  }),
});

export const { useGetMessagesQuery, useAddMessageMutation } = messagesApi;
